(function() {
  const initPromotionalCards = (container) => {
    if (!container) return;
    
    const swiperContainer = container.querySelector('.swiper');
    if (!swiperContainer) return;
    
    // Check if Swiper is available
    if (typeof window.flu === 'undefined' || !window.flu.chunks || !window.flu.chunks.swiper) {
      // Fallback: use CSS scroll if Swiper is not available
      swiperContainer.style.overflowX = 'auto';
      swiperContainer.style.scrollSnapType = 'x mandatory';
      swiperContainer.style.webkitOverflowScrolling = 'touch';
      
      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      const isMobile = window.innerWidth < 720;
      const spacing = isMobile ? 12 : 24;
      
      slides.forEach((slide, index) => {
        slide.style.scrollSnapAlign = 'start';
        if (index < slides.length - 1) {
          slide.style.marginRight = spacing + 'px';
        }
      });
      return;
    }
    
    // Use Swiper if available
    const autoplayEnabled = container.dataset.autoplayEnabled === 'true';
    const autoplayDelay = parseInt(container.dataset.autoplayDelay || '3000', 10);
    
    import(window.flu.chunks.swiper).then(({ Swiper, Navigation, Autoplay }) => {
      const modules = [Navigation];
      if (autoplayEnabled) {
        modules.push(Autoplay);
      }
      
      const swiperConfig = {
        modules: modules,
        slidesPerView: 1.2,
        spaceBetween: 12,
        grabCursor: true,
        preloadImages: false,
        watchSlidesProgress: true,
        breakpoints: {
          720: {
            slidesPerView: 'auto',
            spaceBetween: 24
          },
          1200: {
            slidesPerView: 'auto',
            spaceBetween: 24
          }
        }
      };
      
      if (autoplayEnabled) {
        swiperConfig.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }
      
      new Swiper(swiperContainer, swiperConfig);
    }).catch(() => {
      // Fallback to CSS scroll if import fails
      swiperContainer.style.overflowX = 'auto';
      swiperContainer.style.scrollSnapType = 'x mandatory';
      swiperContainer.style.webkitOverflowScrolling = 'touch';
      
      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      const isMobile = window.innerWidth < 720;
      const spacing = isMobile ? 12 : 24;
      
      slides.forEach((slide, index) => {
        slide.style.scrollSnapAlign = 'start';
        if (index < slides.length - 1) {
          slide.style.marginRight = spacing + 'px';
        }
      });
    });
  };
  
  const initAllPromotionalCards = () => {
    document.querySelectorAll('[data-section-type="promotional-cards"]').forEach((section) => {
      initPromotionalCards(section);
    });
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPromotionalCards);
  } else {
    initAllPromotionalCards();
  }
  
  // Reinitialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="promotional-cards"]');
    if (section) {
      initPromotionalCards(section);
    }
  });
})();

